/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import clsx from 'clsx';

import productDescPreview from '@root/assets/product-photo.png';

import useStyles from './ProductTile.styles';

const ProductTile = ({
  product,
  selectedProduct,
  setSelectedProduct,
}) => {
  const classes = useStyles();
  const isSelected = selectedProduct.id === product.id;
  return (
    <div
      className={clsx(classes.tile,
        { [classes.border]: isSelected })}
      onClick={() => setSelectedProduct(product)}
    >
      <img
        src={product.image.src ? product.image.src : productDescPreview}
        alt={product.image.alt}
        width="100%"
      />
      <div className={classes.tileVendor}>
        {product.vendor}
      </div>
      {product.title}
    </div>
  );
};

export default ProductTile;
